import { FormHelper } from '@/helpers/formHelper';
import { UserHelper } from '@/helpers/user.helper';
import { AlertService } from '@/services/alert.service';
import { AuthenticationService } from '@/services/authentication.service';
import { EmailWithTLDValidator } from '@/validators/EmailWithTLDValidator';
import { PhoneNumberValidator } from '@/validators/PhoneNumberValidator';
import { UserNameValidator } from '@/validators/UserNameValidator';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Address, User, UsersService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { AddressFormComponent } from '../ui-forms/address-form/address.component';

import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
import { InputComponent } from '../ui-forms/input/input.component';

export class ProfileUpdateDialogData {
  user: User;
  showSubscriptionMessage = false;
}

@Component({
  selector: 'app-profile-update-dialog',
  templateUrl: './profile-update-dialog.component.html',
  styleUrls: ['./profile-update-dialog.component.scss'],
  standalone: true,
  imports: [
    ModalBaseComponent,
    NgTemplateOutlet,
    MatDialogModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    AddressFormComponent,
    InputComponent
  ]
})
export class ProfileUpdateDialogComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  dialogTitle: string;
  loading = false;

  addressLegend: string;
  sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ProfileUpdateDialogData,
    private fb: UntypedFormBuilder,
    private userService: UsersService,
    private userHelper: UserHelper,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<ProfileUpdateDialogComponent>,
    private authenticationService: AuthenticationService
  ) {
    this.dialogTitle = 'Modifier mes informations';
  }

  get form_firstName() {
    return this.form.get('firstName') as FormControl<string>;
  }
  get form_name() {
    return this.form.get('name') as FormControl<string>;
  }
  get form_email() {
    return this.form.get('email') as FormControl<string>;
  }
  get form_phoneNumber() {
    return this.form.get('phoneNumber') as FormControl<string>;
  }
  /*get form_companyName() {
    return this.form.get('companyName') as FormControl<string>;
  }
  get form_siret() {
    return this.form.get('siret') as FormControl<string>;
  }
  get form_vatNumber() {
    return this.form.get('vatNumber') as FormControl<string>;
  }*/

  get form_address() {
    return this.form.get('address') as FormControl<Address | null>;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      role: [null, Validators.required],
      firstName: [null, [Validators.required, Validators.maxLength(50), UserNameValidator]],
      name: [null, [Validators.required, Validators.maxLength(50), UserNameValidator]],
      email: [null, [Validators.required, EmailWithTLDValidator]],
      phoneNumber: [null, PhoneNumberValidator],
      /*companyName: [null],
      siret: [null, SiretValidator],
      vatNumber: [null],*/
      address: new FormControl<Address>(null)
    });
    //email field is disabled
    this.form_email.disable();
    this.form.patchValue(this.data.user);
    this.addressLegend = this.userHelper.isRealEstate() ? 'Utilisée pour la facturation' : null;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;

      // reset alerts on submit
      this.alertService.clear();

      // replace spaces by - in names
      this.form_firstName.setValue(this.form_firstName.value.trim().replace(' ', '-'));
      // force uppercase
      this.form_name.setValue(this.form_name.value.trim().replace(' ', '-').toUpperCase());

      //set address field to null if empty
      FormHelper.setFcNullIfAllEmpty(this.form_address);

      this.sub = this.userService.updateUser(this.data.user.uid, this.form.getRawValue()).subscribe({
        next: () => {
          this.alertService.success('Informations mises à jour', true);
          this.authenticationService.refreshUserSession();
          this.loading = false;
          this.dialogRef.close(true);
        },
        error: () => {
          this.loading = false;
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  fillAddressFromProperty() {
    // prevents to open multiple dialog
    /*if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(PropertySelectDialogComponent, {
        data: { ownerOnly: true }
      });

      this.subs.push(
        dialogRef.afterClosed().subscribe((prop) => {
          if (prop && prop.address) {
            this.fAddr('street').setValue(prop.address.street);
            this.fAddr('complement').setValue(prop.address.complement);
            this.fAddr('postalCode').setValue(prop.address.postalCode);
            this.fAddr('city').setValue(prop.address.city);
            this.fAddr('country').setValue(prop.address.country);
          }
        })
      );
    }*/
  }
}
